<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="productDetailSeckillOrderInfo.orders" border style="width: 100%" size="small">
        <el-table-column prop="orderId" :label="$t('productSeckillOrder.orderId')" align="center" />
        <el-table-column prop="prodName" :label="$t('productSeckillOrder.productName')" align="center" />
        <el-table-column prop="buyerName" :label="$t('productSeckillOrder.buyer')" align="center" />
        <el-table-column prop="goodsNum" :label="$t('productSeckillOrder.quantity')" align="center" />
        <el-table-column :label="$t('productSeckillOrder.seckillPrice')" align="center">
          <template #default="{ row }">{{ row.killPrice }}</template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('productSeckillOrder.purchaseTime')" align="center" />
        <el-table-column :label="$t('productSeckillOrder.status')" align="center">
          <template #default="{ row }">{{ row.state == 'C' ? '完成' : '待支付' }}</template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('productSeckillOrder.deadline')" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listProductSeckillOrder } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailSeckillOrder',
  data() {
    return {
      productDetailSeckillOrderInfo: {
        orders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailSeckillOrderInfo.productId = params.productId
      this.loadProductDetailSeckillOrderData()
    },
    async loadProductDetailSeckillOrderData() {
      const res = await listProductSeckillOrder({
          productId: this.productDetailSeckillOrderInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })
      this.productDetailSeckillOrderInfo.orders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailSeckillOrderData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>